import {
  BaseQueryFn,
  EndpointBuilder,
  QueryDefinition,
} from '@reduxjs/toolkit/query';

import type { ISkillRelation } from 'interfaces/Skill.interface';
import type { ICollectionApiResponse } from 'services/api/api.types';
import type {
  ISkillRelationCollectionResponse,
  ISkillRelationsCollectionArgs,
} from './skillRelations.api.types';
import {
  serializeFilters,
  serializeFlatObject,
} from 'services/helper/getPaginationParams.helper';
import { transformCollectionResponse } from 'services/teamHeroApi.helpers';

export const getSkillRelations = (
  build: EndpointBuilder<BaseQueryFn, string, string>
): QueryDefinition<
  ISkillRelationsCollectionArgs,
  BaseQueryFn,
  string,
  ISkillRelationCollectionResponse
> =>
  build.query<ISkillRelationCollectionResponse, ISkillRelationsCollectionArgs>({
    providesTags: ['SkillRelation'],
    query: (queryArg: ISkillRelationsCollectionArgs) => {
      const paginationParamObject = {
        page: queryArg.page,
        itemsPerPage: queryArg.itemsPerPage,
        pagination: queryArg.pagination,
        ...queryArg.order,
      };
      const paginationQuery = serializeFlatObject(paginationParamObject, '?');
      const filterQuery = serializeFilters(queryArg.filters);

      return {
        url: `api/skill_relations${paginationQuery}${filterQuery}`,
      };
    },
    transformResponse: (
      response: ICollectionApiResponse<ISkillRelation>
    ): ISkillRelationCollectionResponse =>
      transformCollectionResponse<ISkillRelation>(response),
  });
